import { render, staticRenderFns } from "./narratorCreate.vue?vue&type=template&id=2dab9dca&"
import script from "./narratorCreate.vue?vue&type=script&lang=js&"
export * from "./narratorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports